import { FormatNumber } from "@chakra-ui/react";
import * as React from "react";

interface FormatBytesProps {
  value: number;
}

export const FormatBytes = ({ value }: FormatBytesProps) => (
  <FormatNumber
    value={value}
    style="unit"
    unit="byte"
    notation="compact"
    unitDisplay="narrow"
  />
);
